import { applicationHandlers } from './applicationHandlers';
import { residencyHandlers } from './residencyHandlers';

export const handlers = [];
export const a = [...applicationHandlers, ...residencyHandlers];
